/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  PaymentRequestsCreationResponse,
  PayoutCreationResponse,
  SinglePaymentRequest
} from '../../schemas';

import { customAxios } from '../../custom-instance';
import type { ErrorType , BodyType } from '../../custom-instance';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Creates payouts for all pending payment requests that have not been processed yet. Returns JSON with the results of each payout, including success or error messages.
 * @summary Creates payouts for pending payment requests
 */
export const createPendingRequestsPayouts = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PayoutCreationResponse>(
      {url: `/api/finances/v1/payment-requests/create-payouts/`, method: 'POST', signal
    },
      options);
    }



export const getCreatePendingRequestsPayoutsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPendingRequestsPayouts>>, TError,void, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof createPendingRequestsPayouts>>, TError,void, TContext> => {

const mutationKey = ['createPendingRequestsPayouts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPendingRequestsPayouts>>, void> = () => {


          return  createPendingRequestsPayouts(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePendingRequestsPayoutsMutationResult = NonNullable<Awaited<ReturnType<typeof createPendingRequestsPayouts>>>

    export type CreatePendingRequestsPayoutsMutationError = ErrorType<unknown>

    /**
 * @summary Creates payouts for pending payment requests
 */
export const useCreatePendingRequestsPayouts = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPendingRequestsPayouts>>, TError,void, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPendingRequestsPayouts>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreatePendingRequestsPayoutsMutationOptions(options), queryClient);
    }
    /**
 * Accepts JSON data containing payment request information, validates it, and processes each payment request. Returns a JSON object with the results of each payment request, including success or error messages.
 * @summary Uploads JSON data of buyer payment requests and submits them if applicable
 */
export const uploadPaymentRequestsJSON = (
    singlePaymentRequest: BodyType<SinglePaymentRequest[]>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaymentRequestsCreationResponse>(
      {url: `/api/finances/v1/payment-requests/submit/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: singlePaymentRequest, signal
    },
      options);
    }



export const getUploadPaymentRequestsJSONMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadPaymentRequestsJSON>>, TError,{data: BodyType<SinglePaymentRequest[]>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadPaymentRequestsJSON>>, TError,{data: BodyType<SinglePaymentRequest[]>}, TContext> => {

const mutationKey = ['uploadPaymentRequestsJSON'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadPaymentRequestsJSON>>, {data: BodyType<SinglePaymentRequest[]>}> = (props) => {
          const {data} = props ?? {};

          return  uploadPaymentRequestsJSON(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadPaymentRequestsJSONMutationResult = NonNullable<Awaited<ReturnType<typeof uploadPaymentRequestsJSON>>>
    export type UploadPaymentRequestsJSONMutationBody = BodyType<SinglePaymentRequest[]>
    export type UploadPaymentRequestsJSONMutationError = ErrorType<unknown>

    /**
 * @summary Uploads JSON data of buyer payment requests and submits them if applicable
 */
export const useUploadPaymentRequestsJSON = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadPaymentRequestsJSON>>, TError,{data: BodyType<SinglePaymentRequest[]>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadPaymentRequestsJSON>>,
        TError,
        {data: BodyType<SinglePaymentRequest[]>},
        TContext
      > => {
      return useMutation(getUploadPaymentRequestsJSONMutationOptions(options), queryClient);
    }
